<template>
	<div class="page" :class="{ [packageName]: true,[deviceName]:true }">
		<div class="page-wrapper">
			<Header :title="title" right :bgStyle="bgStyle" :titleStyle="titleStyle" :leftIcon="leftIcon">
				<template v-slot:right>
					<div class="rightIconBox" @click="goHistory()">
						<img :src="rightIcon" alt="" />
					</div>
				</template>
			</Header>
			<div class="page-content">
				<div v-if="showPayImage && payImg && isltV2()" class="payImg">
					<img :src="payImg" class="pay-image" @click="openBrowser" alt="" />
					<img :src="btn" class="btn-img" alt="" @click="openBrowser" />
				</div>
				<div :class="`topLabel ${getColor(1)} ${packageName} ${deviceName}`">
					<div class="top-index">Bonus Balance:</div>
					<img class="imgIcon top-index" :src="cointImg" alt="" />
					<div :class="appInfo == 'Webfiction' && 'topFic'" class="userBonus top-index">
						{{ dataInfo.userBonus }}
					</div>
				</div>
				<div class="bigCanGetBox top-index">
					<div :class="`canGetBox ${getColor(2)} ${packageName}  ${deviceName}`">
						<div class="getInfoWrap">
							<div class="left_box">
								<div class="title">
									Extra
									<span>{{ dataInfo.finishAllBonus }}</span>
									Bonus for finishing all.
								</div>
								<div class="process-box">
									<div class="process-bar" :style="{ width: processWidth }">
										<div class="icon"></div>
									</div>
								</div>
								<div class="tasksNumBox">
									<div>
										<span>{{ noDo }}</span>
										tasks left to be finished as yet.
									</div>
								</div>
							</div>
							<div class="right_box">
								<img :src="positionBg" class="bg" alt="" />
								<img :src="lhIcon" class="imgIcon" alt="" />
								<!-- -->
								<div @click="handlerClick" :class="{ disabled: btnDisabled }" class="taskBtn">Claim</div>
							</div>
						</div>
					</div>
				</div>
				<div class="loading-box" v-if="isLoading">
					<van-loading />
				</div>
				<template v-else>
					<div class="qianBox">
						<div class="qianTitle">Daily Check-in</div>
						<template v-if="!['LoveNovel', 'LiteCrazyNovel', 'StoryRover', 'DailyBooks'].includes(packageName)">
							<div class="qianList" v-if="dataInfo.signIn && dataInfo.signIn.items.length">
								<div v-if="packageName === 'GreatNovels'" class="contuneSign">
									{{ dataInfo.signIn.continuousSignIn > 7 ? 7 : dataInfo.signIn.continuousSignIn }}
									Days Continuous check in
								</div>
								<div class="process" v-if="['InfinityStories'].includes(packageName)">
									<div class="process-inner" :style="{ width: `${(continuousSignIn - 1) * 14.28 + 7.14}%` }"></div>
								</div>
								<div class="qiandao-top">
									<div v-for="(item, index) of dataInfo.signIn && dataInfo.signIn.items" class="signInOne" :key="index">
										<div
											class="signIn-item"
											:class="{
												[deviceName]: true,
												[getColor(3)]: dataInfo.signIn.continuousSignIn >= index + 1,
												[packageName]: true,
												cur: dataInfo.signIn.continuousSignIn >= 8 ? index + 1 == 7 : dataInfo.signIn.continuousSignIn == index + 1,
												signed: dataInfo.signIn.continuousSignIn >= index + 1,
											}"
										>
											<div :class="`checkName ${packageName}  ${deviceName}`">
												{{ index == 0 ? 'Day 1' : `Day ${index + 1}` }}
											</div>
											<template v-if="['InfinityStories'].includes(packageName)">
												<div class="dot"></div>
												<div class="check-img">
													<img :src="require('@/assets/images/check.png')" alt="" />
												</div>
											</template>

											<template v-if="dataInfo.signIn.continuousSignIn >= index + 1">
												<svg-icon v-if="packageName == 'Readfic' && deviceName == 'ios' || packageName == 'iRomance'" iconClass="readfic-g" :className="`icon-tick ${deviceName} ${packageName}`"></svg-icon>
												<svg-icon iconClass="g" v-else :className="`icon-tick ${deviceName} ${packageName}`"></svg-icon>
											</template>
											<img class="uncheck" v-else :src="packageName === 'GreatNovels' ? require('@/assets/images/check-GreatNovelsIcon.png') : require('@/assets/images/check-icon.png')" alt="" />
											<img class="arrow" :src="require('@/assets/images/top-arrow.png')" alt="" />
										</div>
									</div>
								</div>
								<div class="check-info" :class="{ [packageName]: true, [`${deviceName}`]: true }" v-if="Object.keys(todayCheckInData).length">
									<template v-if="!['readNow', 'Candy', 'GoodFic', 'Sweet'].includes(packageName)">
										<!-- Readfic 安卓和ios是两套皮肤 -->

										<template v-if="packageName == 'Readfic' && deviceName != 'ios'">
											<div class="awards" v-if="(todayCheckInData && todayCheckInData.awardAmount) || (todayCheckInData && todayCheckInData.bonusAmount)">
												<img class="loginCoint" :src="bigCointImg" alt="" />
												<div class="reward">
													Bonus
													<span>+{{ todayCheckInData.bonusAmount ? todayCheckInData.bonusAmount : todayCheckInData.awardAmount }}</span>
												</div>
											</div>

											<div class="awards" v-if="todayCheckInData && todayCheckInData.ticketAmount && !excludePackage(packageName)">
												<img class="loginCoint" :src="passCardImg" alt="" />
												<div class="reward">
													Pass Card
													<span>+{{ todayCheckInData.ticketAmount || 0 }}</span>
												</div>
											</div>
										</template>
										<template v-else>
											<div class="awards-box" :class="{[packageName]:true,[deviceName]:true}">
												<div class="awards" v-if="(todayCheckInData && todayCheckInData.awardAmount) || (todayCheckInData && todayCheckInData.bonusAmount)">
												<img class="loginCoint" :src="bigCointImg" alt="" />
													<div class="reward">
														Bonus
														<span>+{{ todayCheckInData.bonusAmount ? todayCheckInData.bonusAmount : todayCheckInData.awardAmount }}</span>
													</div>
												</div>
												<div class="awards" v-if="todayCheckInData && todayCheckInData.ticketAmount && !excludePackage(packageName)">
												<img class="loginCoint" :src="passCardImg" alt="" />
													<div class="reward">
														Pass Card
														<span>+{{ todayCheckInData.ticketAmount || 0 }}</span>
													</div>
												</div>
											</div>
										</template>
									</template>
									<template v-else>
										<div class="success-received">Successfully received</div>
										<div class="awards-box">
											<div class="awards" v-if="(todayCheckInData && todayCheckInData.awardAmount) || (todayCheckInData && todayCheckInData.bonusAmount)">
												<div class="reward">
													Bonus
													<span>+{{ todayCheckInData.bonusAmount ? todayCheckInData.bonusAmount : todayCheckInData.awardAmount }}</span>
												</div>
											</div>
											<div class="awards" v-if="todayCheckInData && todayCheckInData.ticketAmount && !excludePackage(packageName)">
												<div class="reward">
													Pass Card
													<span>+{{ todayCheckInData.ticketAmount || 0 }}</span>
												</div>
											</div>
										</div>
									</template>
								</div>
							</div>
						</template>
						<template v-else>
							<div class="sign-topbox" :class="{ [packageName]: true, [`${deviceName}`]: true }">
								<div class="year">{{ year }}</div>
								<div class="time">{{ week }},{{ time }}</div>
							</div>
							<div class="qianList LoveNovel" :class="{ [packageName]: true }" v-if="dataInfo.signIn && dataInfo.signIn.items.length">
								<div class="qiandao-top">
									<div v-for="(item, index) of dataInfo.signIn && dataInfo.signIn.items" class="signInOne" :key="index">
										<div
											class="signIn-item CrazyNovel"
											:class="{
												[getColor(3)]: dataInfo.signIn.continuousSignIn >= index + 1,
												cur: dataInfo.signIn.continuousSignIn >= 8 ? index + 1 == 7 : dataInfo.signIn.continuousSignIn == index + 1,
												signed: dataInfo.signIn.continuousSignIn >= index + 1,
												[packageName]: true,
											}"
										>
											<svg-icon iconClass="g" v-if="dataInfo.signIn.continuousSignIn >= index + 1" :className="`icon-tick ${packageName} ${deviceName}`"></svg-icon>
											<img v-else :src="packageName === 'StoryRover' || packageName === 'DailyBooks' ? require('@/assets/images/check-StoryRover.png') : packageName === 'GreatNovels' ? require('@/assets/images/check-GreatNovelsIcon.png') : require('@/assets/images/lw-icon.png')" alt="" />
											<div :class="`checkName ${packageName} ${deviceName}`">
												{{ index == 0 ? 'Day 1' : `Day ${index + 1}` }}
											</div>
										</div>
									</div>
								</div>
								<template v-if="Object.keys(todayCheckInData).length">
									<div class="success-received">Successfully received</div>
									<div class="CrazyNovel-checkbox">
										<div class="check-info">
											<div class="awards" v-if="(todayCheckInData && todayCheckInData.awardAmount) || (todayCheckInData && todayCheckInData.bonusAmount)">
												<div class="reward">
													Bonus
													<span>+{{ todayCheckInData.bonusAmount ? todayCheckInData.bonusAmount : todayCheckInData.awardAmount }}</span>
												</div>
											</div>
											<div class="awards" v-if="todayCheckInData && todayCheckInData.ticketAmount && !excludePackage(packageName)">
												<div class="reward">
													Pass Card
													<span>+{{ todayCheckInData.ticketAmount || 0 }}</span>
												</div>
											</div>
										</div>
									</div>
								</template>
							</div>
						</template>
					</div>
					<div v-for="(item, index) of dataInfo.bonusItemVOS" :key="index" class="tasksBox">
						<div :class="`boxTitle`">
							{{ item.title }}
						</div>
						<div class="taskOneBox" v-for="(item2, index2) of item.taskVOS || []" :key="item2.title">
							<div class="taskName">{{ item2.title }}</div>
							<div class="taskLabel">{{ item2.topHint }}</div>
							<template v-if="!['LoveNovel', 'LiteCrazyNovel', 'readNow', 'StoryRover', 'DailyBooks', 'InfinityStories', 'Candy', 'GoodFic', 'Sweet'].includes(packageName)">
								<div class="taskGetNumBox">
									<img class="taskImg" :src="cointImg" alt="" />
									<div :class="`taskNum ${getColor(5)} ${packageName} ${deviceName}`">
										{{ item2.awardAmount }}
									</div>
								</div>
							</template>
							<template v-else>
								<div class="taskGetNumBox">
									<div class="taskNum awardAmount" :class="{ [packageName]: true, [`${deviceName}`]: true }">
										+{{ item2.awardAmount }}
										<span>Bonus</span>
									</div>
								</div>
							</template>
							<div :class="`taskBtn ${getColor(6)} ${packageName} ${deviceName} ${item2.done && 'isDo'}`" @click="nativeClick(item2)">
								{{ item2.button }}
							</div>
						</div>
					</div>
				</template>
			</div>
		</div>
		<div v-show="loginPop" class="myDialog" @touchmove.prevent />
		<div v-show="loginPop" class="loginPop">
			<div class="popBox" :class="{ [packageName]: true, [`${deviceName}`]: true }">
				<div class="bgImgBox">
					<div class="close" @click="loginPop = false" v-if="['LoveNovel', 'LiteCrazyNovel', 'StoryRover', 'DailyBooks'].includes(packageName)">
						<img v-if="packageName == 'DailyBooks'" :src="require('@/assets/images/DailyBooks-close.png')" alt="" />
						<img v-else-if="packageName == 'StoryRover'" :src="require('@/assets/images/StoryRover-close.png')" alt="" />
						<img v-else-if="packageName != 'LoveNovel'" :src="require('@/assets/images/close.png')" alt="" />
						<img v-else :src="require('@/assets/images/loveNovel-close.png')" alt="" />
					</div>
					<img class="popBg" :src="popBg" alt="" />
					<img class="successImg" :src="getSuccessImg()" alt="" />
					<div class="successLabel">{{ successLabel }}</div>
					<div :class="`successCountBox ${getColor(5)} ${packageName} ${deviceName}`">
						<template v-if="!getNum.bonus">
							<template v-if="hasIcon(packageName)">
								<img class="loginCoint" :src="bigCointImg" alt="" />
								<div class="add">+</div>
								<div class="addCount">{{ getNum }}</div>
							</template>
							<template v-else>
								<div class="addCount">
									Bonus
									<span>+{{ getNum }}</span>
								</div>
							</template>
						</template>
						<div class="flex" v-else>
							<template v-if="hasIcon(packageName)">
								<div class="award-item" v-if="getNum.bonus">
									<img class="loginCoint" :src="bigCointImg" alt="" />
									<div class="add">+</div>
									<div class="addCount">{{ getNum.bonus }}</div>
								</div>
								<div class="award-item" v-if="getNum.freePass && !excludePackage(packageName)">
									<img class="loginCoint" :src="passCardImg" alt="" />
									<div class="add">+</div>
									<div class="addCount">{{ getNum.freePass }}</div>
								</div>
							</template>
							<template v-else>
								<div class="award-item" v-if="getNum.bonus">
									<div class="addCount">
										Bonus
										<span>+{{ getNum.bonus }}</span>
									</div>
								</div>
								<div class="award-item" v-if="getNum.freePass && !excludePackage(packageName)">
									<div class="addCount">
										Pass Card
										<span>+{{ getNum.freePass }}</span>
									</div>
								</div>
							</template>
						</div>
					</div>
					<div :class="`successBtn ${getColor(7)} ${packageName} ${deviceName}`" @click="loginPop = false">Receive</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Header from '@/components/Header'
import SvgIcon from '@/components/SvgIcon.vue'
import { getCookie, getAppConfig } from '@/utils'
import { invokeNative } from '@/utils/hybrid'
import Pop from '@/components/popBg'
import { Toast, Loading } from 'vant'
import { encode, decode } from 'js-base64'
import { getChannel } from '@/utils/getChannel'

const boxStyle = {
	maxHeight: '11rem',
	padding: '0.6rem 0.35rem',
}

export default {
	components: {
		Header,
		Pop,
		SvgIcon,
		[Loading.name]: Loading,
	},
	computed: {
		week() {
			return this.weeks[new Date().getDay()]
		},
		time() {
			return this.timestampToTime(+new Date())
		},
		year() {
			return new Date().getFullYear()
		},
	},
	data() {
		return {
			isLoading: true,
			weeks: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
			todayCheckInData: {},
			bgStyle: {
				background: '#fff',
			},
			titleStyle: {
				color: '#00000A',
			},
			leftIcon: 'back.png',
			processWidth: 0,
			payImg: null, // 跳转到第三方支付的图片
			showPayImage: false,
			passCardImg: require('@/assets/images/passcard.png'),
			btn: require('@/assets/images/topUp-btn.png'),
			title: 'Earn Bonus',
			rightIcon: require('@/assets/icons/bonusInfo.png'),
			cointImg: require('@/assets/icons/coinIcon.png'),
			bigCointImg: require('@/assets/images/bigIcon.png'),
			icon1: require('@/assets/icons/welfareIcon1.png'),
			icon2: require('@/assets/icons/welfareIcon2.png'),
			checkImg: require('@/assets/icons/checkImg.png'),
			checkImg_novel: require('@/assets/icons/checkImg_novel.png'),
			checkImg_story: require('@/assets/icons/checkImg_story.png'),
			checkImg_fiction: require('@/assets/icons/checkImg_fiction.png'),
			sevenImg: 'https://img.kandianreader.com/img/526217b3e855ab9f8adc0f1bc8959f83',
			popBg: require('@/assets/images/loginPopBg.png'),
			positionBg: require('@/assets/images/position.png'),
			lhIcon: require('@/assets/images/lh.png'),
			checkIndex: 0,
			boxStyle,
			btnDisabled: true,
			dayList: [
				{
					name: '1Day',
					num: '5 Bonus',
				},
				{
					name: '2Days',
					num: '5 Bonus',
				},
				{
					name: '3Days',
					num: '5 Bonus',
				},
				{
					name: '4Days',
					num: '8 Bonus',
				},
				{
					name: '5Days',
					num: '8 Bonus',
				},
				{
					name: '6Days',
					num: '8 Bonus',
				},
				{
					name: '7+ Days',
					num: '10 Bonus',
				},
			],
			newTaskBox: [
				{
					title: 'Sign in',
					label: 'Log in with your account',
					count: 5,
				},
				{
					title: 'Add to library',
					label: 'Add one novel to your library',
					count: 10,
				},
			],
			loginPop: false,
			dataInfo: {},
			noDo: 0,
			getNum: 0,
			successLabel: 'Check in successfully !',
			appInfo: 'iStory',
			packageName: 'iStory',
			deviceName: 'android',
			continuousSignIn: 0,
		}
	},
	async created() {
		window.getData = this.getData
		this.getData()

		this.appInfo = getAppConfig().balanceTheme // 皮肤
		this.packageName = getChannel() // 包名
		this.deviceName = this.env.isIOS ? 'ios' : 'android'
		if (this.packageName == 'RomanceZone' || this.packageName == 'LiteRomanceZone') {
			this.cointImg = require('@/assets/icons/Romacezone-bonus.png')
			this.passCardImg = require('@/assets/icons/RomaceZone-passCard.png')
			this.bigCointImg = require('@/assets/icons/RomaceZone-bigCoins.png')
		} else if (this.packageName == 'GreatNovels') {
			this.cointImg = require('@/assets/icons/GreatNovel-bigbonus.png')
			this.passCardImg = require('@/assets/icons/GreatNovel-passcard.png')
			this.bigCointImg = require('@/assets/icons/GreatNovel-bonus.png')
			this.bgStyle.background = 'transparent'
			this.titleStyle.color = `#fff`
			this.leftIcon = 'back_white.png'
			this.lhIcon = require('@/assets/images/GreatNovels-lh.png') // 礼盒icon
			this.positionBg = require('@/assets/images/GreatNovels-position.png')
			this.rightIcon = require('@/assets/icons/right-white.png')
		} else if (this.packageName == 'Libfic' || this.packageName == 'LiteLibfic') {
			this.cointImg = require('@/assets/icons/Libfic-bonus.png')
			this.passCardImg = require('@/assets/icons/Libfic-passCard.png')
			this.bigCointImg = require('@/assets/icons/Libfic-bigBonus.png')
		} else if (this.packageName == 'Mobooks' && !this.env.isIOS) {
			this.cointImg = require('@/assets/icons/Mobooks-bonus.png')
			this.passCardImg = require('@/assets/icons/Mobooks-passcard.png')
			this.bigCointImg = require('@/assets/icons/Mobooks-bonus.png')
		} else if (this.packageName == 'Fictlf') {
			this.cointImg = require('@/assets/icons/Fictlf-sbonus.png')
			this.bigCointImg = require('@/assets/icons/Fictlf-bonus.png')
			this.passCardImg = require('@/assets/icons/Fictlf-passcard.png')
		} else if (this.packageName === 'Shepherd' || (this.packageName == 'Mobooks' && this.env.isIOS)) {
			this.cointImg = require('@/assets/icons/Shepherd-bonus.png')
			this.bigCointImg = require('@/assets/icons/Shepherd-Bigbonus.png')
			this.passCardImg = require('@/assets/icons/Shepherd-passcard.png')
		} else if (this.packageName === 'FunStory') {
			this.cointImg = require('@/assets/icons/FunStory-bonus.png')
			this.bigCointImg = require('@/assets/icons/FunStory-Bigbonus.png')
			this.passCardImg = require('@/assets/icons/FunStory-passcard.png')
		} else if (this.packageName === 'MyNovel') {
			this.cointImg = require('@/assets/icons/MyNovel-Bigbonus.png')
			this.bigCointImg = require('@/assets/icons/MyNovel-Bigbonus.png')
			this.passCardImg = require('@/assets/icons/MyNovel-passcard.png')
		}else if (this.packageName === 'Topicks') {
			if (!this.env.isIOS) {
				this.cointImg = require('@/assets/icons/Topicks-bonus.png')
				this.bigCointImg = require('@/assets/icons/Topicks-Bigbonus.png')
				this.passCardImg = require('@/assets/icons/Topicks-passcard.png')
			} else {
				this.cointImg = require('@/assets/icons/Topicks-ios-bonus.png')
				this.bigCointImg = require('@/assets/icons/Topicks-ios-Bigbonus.png')
				this.passCardImg = require('@/assets/icons/Topicks-ios-passcard.png')
			}
		} else if (this.packageName === 'Mylib') {
			this.cointImg = require('@/assets/icons/Mylib-bonus.png')
			this.bigCointImg = require('@/assets/icons/Mylib-Bigbonus.png')
			this.passCardImg = require('@/assets/icons/Mylib-passcard.png')
		} else if (this.packageName === 'NovelHut') {
			this.cointImg = require('@/assets/icons/NovelHut-bigBonus.png')
			this.bigCointImg = require('@/assets/icons/NovelHut-bonus.png')
			this.passCardImg = require('@/assets/icons/NovelHut-passcard.png')
		} else if (this.packageName === 'FicAddict') {
			this.bigCointImg = require('@/assets/icons/FicAddict-bigBonus.png')
			this.cointImg = require('@/assets/icons/FicAddict-bonus.png')
			this.passCardImg = require('@/assets/icons/FicAddict-passcard.png')
		} else if (this.packageName === 'PocketEreader' || this.packageName === 'PocketEbooks' || this.packageName === 'Dreams') {
			this.bigCointImg = require('@/assets/icons/PocketEreader-bigBonus.png')
			this.cointImg = require('@/assets/icons/PocketEreader-bonus.png')
			this.passCardImg = require('@/assets/icons/PocketEreader-passcard.png')
		} else if (this.packageName == 'InfinityStories') {
			this.rightIcon = require('@/assets/icons/InfinityStories-right.png')
		}
		console.log(this.packageName, 'packageName')

		this.getSpecialProduct()

		if (!localStorage.getItem('isLoad')) {
			localStorage.setItem('isLoad', 1)
		} else {
			localStorage.setItem('isLoad', localStorage.getItem('isLoad') + 1)
		}

		if (localStorage.getItem('endTask')) {
			// 把缓存的每日任务删掉
			let endTask = JSON.parse(localStorage.getItem('endTask')) || []
			let other = endTask.filter(item => item.taskType != 3)
			let dayTask = endTask.filter(item => item.taskType == 3 && item.date == new Date().format('yyyy-MM-dd'))
			localStorage.setItem('endTask', JSON.stringify(other.concat(dayTask)))
		}
	},
	mounted() {
		if (this.packageName == 'GreatNovels') {
			document.addEventListener('scroll', this.handlerScroll, false)
		}
	},
	beforeUnmount() {
		if (this.packageName == 'GreatNovels') {
			document.removeEventListener('scroll', this.handlerScroll, false)
		}
	},
	methods: {
		excludePackage(packageName){
			if(packageName == 'WhatsRead' || packageName == 'FicFun' && this.deviceName == 'ios'){
				return true
			}
			return false;
		},
		hasIcon(packageName){
			if(packageName == 'Readfic' && this.deviceName == 'ios'  || packageName == 'iRomance'){
				return false;
			}
			return !['LoveNovel', 'LiteCrazyNovel', 'readNow', 'StoryRover', 'DailyBooks', 'Candy', 'GoodFic', 'Sweet', 'InfinityStories'].includes(packageName)
		},
		isltV2() {
			let versionStr = getCookie('X-App-Info').split('/')[0]
			if (versionStr) {
				return this.compareVersionsToNum(versionStr, '2.0.0') < 0
			}
			return false
		},
		timestampToTime(timestamp) {
			if (![undefined, null].includes(timestamp)) {
				var date = new Date(timestamp) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
				var Y = date.getFullYear()
				var M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
				var D = date.getDate() >= 10 ? date.getDate() : `0${date.getDate()}`
				let newM = this.getMounth(M)
				return `${newM} ${D}`
			} else {
				return ''
			}
		},
		getMounth(M) {
			let allMounth = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
			let mounth = allMounth.filter((item, i) => M == i + 1)[0]
			return mounth
		},
		handlerScroll() {
			let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
			let opacity = scrollTop * 0.02
			if (opacity > 1) {
				opacity = 1
			}
			this.bgStyle.background = `rgba(255,255,255,${opacity})`
			this.titleStyle.color = opacity < 0.3 ? `rgba(255,255,255,1)` : `rgba(0,0,0,1)`
			this.leftIcon = opacity > 0.3 ? 'back.png' : 'back_white.png'
			this.rightIcon = opacity > 0.3 ? require('@/assets/icons/right-black.png') : require('@/assets/icons/right-white.png')
		},
		compareVersions(ver1, ver2) {
			var version1pre = parseFloat(ver1)
			var version2pre = parseFloat(ver2)
			var version1next = ver1.replace(version1pre + '.', '')
			var version2next = ver2.replace(version2pre + '.', '')
			if (version1pre > version2pre) {
				return true
			} else if (version1pre < version2pre) {
				return false
			} else {
				if (version1next >= version2next) {
					return true
				} else {
					return false
				}
			}
		},
		compareVersionsToNum(ver1, ver2) {
			// -1 0 1 : 小于，等于，大于
			var version1pre = parseFloat(ver1)
			var version2pre = parseFloat(ver2)
			var version1next = ver1.replace(version1pre + '.', '')
			var version2next = ver2.replace(version2pre + '.', '')
			if (version1pre > version2pre) {
				return 1
			} else if (version1pre < version2pre) {
				return -1
			} else {
				if (version1next > version2next) {
					return 1
				} else if (version1next == version2next) {
					return 0
				} else {
					return -1
				}
			}
		},
		handlerClick() {
			if (this.btnDisabled) return
			this.$http.post('/nc-user-service/activity/allDailyTaskAward').then(data => {
				this.getNum = data.awardAmount // awardType 0金币，1书券
				this.successLabel = 'Complete the task !'
				this.loginPop = true
				this.btnDisabled = true
				this.getData()
			})
		},
		setProcessBarWidth() {
			let total = (this.finishTaskDayNum / this.allNum) * 100 + '%'
			if (total == '100%' && !this.allDailyTaskAward) {
				this.btnDisabled = false
			} else {
				this.btnDisabled = true
			}
			this.processWidth = total
		},
		openBrowser() {
			let versionStr = getCookie('X-App-Info').split('/')[0]
			if (this.compareVersionsToNum(versionStr, '2.3.0') > -1) {
				this.goNative('topUp')
				return
			}
			let p = {
				userId: this.userId,
				device: getCookie('device') || 'KANDIANWEB_432715271594280301800',
				'x-app-info': getCookie('X-App-Info'),
				token: getCookie('token'),
				'carrier-filter': getCookie('carrier-filter') || '',
				'language-filter': getCookie('language-filter') || '',
				'country-filter': getCookie('country-filter') || '',
				'tz-filter': getCookie('tz-filter') || '',
			}
			const action = 'goToBrowser'
			const params = {
				url: encodeURIComponent(`${this.payUrl}?p=${encode(JSON.stringify(p))}`),
			}
			invokeNative(params, action)
		},
		// getSpecialProduct() {
		//     this.$http.get('/nc-user-service/account/specialProduct').then((data) => {
		//         // this.payImg='https://img.novelmanga.com/cs/17f359b01bff8791e615e3221cb4f9bd';
		//         // this.payUrl=data.url || 'https://pay.novelmanga.com/';

		//         this.payImg = require('@/assets/images/topUp-banner.png')
		//         this.payUrl = data.url || 'https://pay.novelmanga.com/'
		//     })
		// },
		getSpecialProduct() {
			this.$http.get('/nc-user-service/account/specialProduct').then(data => {
				this.payImg = require('@/assets/images/topUp-banner.png')
				this.payUrl = data.url
				if (data.url) {
					this.showPayImage = true
				}
				if (this.showPayImage) {
					this.getUserMsg() // 获取用户数据
				}
			})
		},
		getUserMsg() {
			// 获取用户信息
			return this.$http.get('/nc-user-service/account/getUserId').then(data => {
				this.userId = data
			})
		},
		loadingPage() {
			this.getData()
		},
		getData() {
			return this.$http
				.get('/nc-user-service/activity/bonus')
				.then(data => {
					this.isLoading = false
					let num = 0,
						allDayNum = 0,
						finishTaskDayNum = 0,
						taskDoneArr = []
					// this.dataInfo = data
					// 是否已经领取过
					if (data.signIn && data.signIn.items) {
						this.todayCheckInData = data.signIn.items[data.signIn.continuousSignIn - 1 < 0 ? 0 : data.signIn.continuousSignIn >= 8 ? 6 : data.signIn.continuousSignIn - 1]
						this.continuousSignIn = data.signIn.continuousSignIn
						console.log(this.todayCheckInData, 'todayCheckInData')
					}
					// console.log(data.signIn.continuousSignIn,'continueSign');

					this.allDailyTaskAward = data.allDailyTaskAward
					if (data.bonusItemVOS && data.bonusItemVOS.length > 0) {
                        console.log(data.bonusItemVOS,'bonusItemVOS')
						let newbieTaskIndex = data.bonusItemVOS.findIndex(item => item.type != 2) // 新手任务index
						let dayTaskIndex = data.bonusItemVOS.findIndex(item => item.type == 2) // 每日任务index
                        // console.log(newbieTaskIndex,'newbieTaskIndex')
                        if (this.env.isIOS) {
                            if (newbieTaskIndex > -1) {
                                // 'Mobooks','Shepherd','eReader','iComics','Funtel'
                                // if (!['Funtel'].includes(this.packageName)) {
                                data.bonusItemVOS[newbieTaskIndex].taskVOS = data.bonusItemVOS[newbieTaskIndex].taskVOS.filter(item => {
                                    // 去掉五星评价
                                    return !(item.taskType == 1 && item.type == 3)
                                })
                                // }
                            }
                        }
						// 正常情况:0-新手任务 1-每日任务
						if (this.packageName == 'HiReader') {
							data.bonusItemVOS[newbieTaskIndex].taskVOS = data.bonusItemVOS[newbieTaskIndex].taskVOS.filter(item => {
								return !((item.taskType == 1 && item.type == 6) || (item.taskType == 1 && item.type == 4) || (item.taskType == 1 && item.type == 3) || (item.taskType == 1 && item.type == 7))
							})
						} else if (['FunStory','MyNovel'].includes(this.packageName)) {
							data.bonusItemVOS[newbieTaskIndex].taskVOS = data.bonusItemVOS[newbieTaskIndex].taskVOS.filter(item => {
								// 去掉邮箱验证
								return !(item.taskType == 1 && item.type == 6)
							})
						} else if (this.env.isIOS) {
							if (this.packageName == 'GoodStoryWeb' && dayTaskIndex > -1) {
								data.bonusItemVOS[dayTaskIndex].taskVOS = data.bonusItemVOS[dayTaskIndex].taskVOS.filter(item => {
									// 去掉五星评价
									return !(item.taskType == 3 && item.type == 1)
								})
							}
                            if(this.packageName == 'Funtel'){ // funtel
                                data.bonusItemVOS[newbieTaskIndex].taskVOS = data.bonusItemVOS[newbieTaskIndex].taskVOS.filter(item => {
                                    // return !(item.taskType == 1 && item.type == 4)
                                    return !((item.taskType == 1 && item.type == 6) || (item.taskType == 1 && item.type == 4) || (item.taskType == 1 && item.type == 3) || (item.taskType == 1 && item.type == 7))
                                })
                            }
							// 'PopFic'  packageName == 'Readfic' && this.deviceName == 'ios'  || packageName == 'iRomance'
							if (['eReader','Readfic','InfinityStories', 'GreatNovels', 'Shepherd', 'readNow', 'iComics', 'WeNovel', 'Candy', 'GoodFic', 'Sweet', 'Mobooks', 'Funtel', 'WhatsRead', 'PopFic','iRomance','FicFun','BookReader'].includes(this.packageName) && newbieTaskIndex > -1) {
								data.bonusItemVOS[newbieTaskIndex].taskVOS = data.bonusItemVOS[newbieTaskIndex].taskVOS.filter(item => {
									// 去掉邮箱验证
									return !(item.taskType == 1 && item.type == 6)
								})
								if (['WeNovel', 'WhatsRead','FicFun'].includes(this.packageName)) {
									data.bonusItemVOS[newbieTaskIndex].taskVOS = data.bonusItemVOS[newbieTaskIndex].taskVOS.filter(item => {
										// Turn on notification
										return !(item.taskType == 1 && item.type == 4)
									})
								}
							}
						}

						if (dayTaskIndex > -1) {
							let dayTasks = data.bonusItemVOS[dayTaskIndex].taskVOS
							let watchVideoIndex = dayTasks.findIndex(item => item.taskType == 3 && item.type == 4)
							if (watchVideoIndex > -1 && !['free2read', 'FreeRead'].includes(this.packageName)) {
								let versionStr = getCookie('X-App-Info').split('/')[0]
								if (versionStr) {
									let flag = true
									let appsV2 = ['GoodReader','LoveNovel','Funtel', 'LiteLibfic', 'LiteCrazyNovel', 'LiteRomanceZone', 'RomanceStories', 'Webnovel', 'GoodStory', 'hotNovel', 'readNow', 'Candy', 'GoodFic', 'Sweet', 'Webfiction', 'PocketEbooks', 'Webstories', 'topFic', 'readme', 'PocketEreader', 'Dreams', 'weRead', 'HiReader', 'shepherdNovel', 'topStories', 'Chapters', 'StoryHouse', 'iNovel', 'NovelFox', 'GoodNovel', 'CrazyFic', 'Read4Fun', 'PopFic', 'FunFic', 'FancyNovel', 'topNovel']
									if (appsV2.includes(this.packageName) && (this.compareVersionsToNum(versionStr, '2.0.0') == 1 || this.compareVersionsToNum(versionStr, '2.0.0') == 0)) {
										flag = false
									}
									if (flag) {
										if (this.compareVersionsToNum(versionStr, '1.8.4') == 1 || this.compareVersionsToNum(versionStr, '1.8.4') == 0) {
											// 大于等于1.8.4 去掉广告
											data.bonusItemVOS[1].taskVOS = data.bonusItemVOS[1].taskVOS.filter(item => !(item.taskType == 3 && item.type == 4))
										}
									}
								}
							}
						}

						for (let j = data.bonusItemVOS.length - 1; j > -1; j--) {
							let typeIndex = j,
								item = data.bonusItemVOS[j]

							// console.log(item.taskVOS, "taskVOS");
							let isAllDone = item.taskVOS.every(task => task.done)

							for (let i = item.taskVOS.length - 1; i > -1; i--) {
								let item2 = item.taskVOS[i],
									index = i
								if (!item2.done && item2.taskType > 1) {
									// 计算没有完成任务的总个数
									num += 1
								}
								// item2.done = true;
								if (item2.done) {
									// 已经完成的任务
									if (localStorage.getItem('isLoad') == 1) {
										localStorage.setItem('isLoad', localStorage.getItem('isLoad') + 1)
										this.endDoneTasks({
											...item2,
											date: new Date(new Date().setHours(0, 0, 0, 0)).format('yyyy-MM-dd'),
										})
									} else {
										taskDoneArr.push(item2)
									}
									item.taskVOS.splice(index, 1)
								}
								if (item2.taskType > 1) {
									allDayNum += 1
									if (item2.done) {
										finishTaskDayNum += 1
									}
									// if (item2.title == 'Watch videos') {
									//     if (item2.topHint.match(/(\d+)\//)) {
									//         let completeNum = Number(item2.topHint.match(/(\d+)\//)[1]);
									//         finishTaskDayNum += item2.awardAmount * completeNum;
									//     }
									// }
								}
							}
							if (isAllDone) {
								data.bonusItemVOS.splice(typeIndex, 1)
							}
						}
					}
					this.noDo = num
					this.finishTaskDayNum = finishTaskDayNum
					console.log(finishTaskDayNum, 'finishTaskDayNum')
					this.allNum = allDayNum

					// finishAllBonus：每天的福利奖励
					// this.allNum = data.finishAllBonus;
					console.log(data.finishAllBonus, 'finishAllBonus')
					console.log(finishTaskDayNum, 'finishTaskDayNum')
					this.dataInfo = data

					this.setProcessBarWidth()
					console.log(taskDoneArr, 'taskDoneArr')
					setTimeout(() => {
						if (data.signIn && !data.signIn.signedToday) {
							this.login()
						} else {
							// this.popupDoneTask(taskDoneArr);
						}
					}, 500)
					this.popupDoneTask(taskDoneArr)
				})
				.catch(err => {
					console.log(err, 'err')
					Toast(err.msg)
					this.isLoading = false
					// Toast(err, 'err')
				})
		},
		popupDoneTask(doneTasks) {
			console.log(doneTasks, 'doneTasks')
			let endTaskTitle = (JSON.parse(localStorage.getItem('endTask')) || []).map(item => item.title)
			// Toast(JSON.stringify(endTaskTitle), 'endTaskTitle')
			let otherData = doneTasks.filter(task => !endTaskTitle.includes(task.title))
			let currentTask = (otherData[0] && otherData[0].title) || ''
			if (currentTask == 'Sign in' || currentTask == 'Watch videos') return

			if (currentTask) {
				let index = doneTasks.findIndex(item => item.title == currentTask)
				if (index > -1) {
					this.getNum = doneTasks[index].awardAmount
					this.successLabel = doneTasks[index].title + ' successfully !'
					this.loginPop = true

					this.endDoneTasks({
						...doneTasks[index],
						date: new Date(new Date().setHours(0, 0, 0, 0)).format('yyyy-MM-dd'),
					})
				}
			}
		},
		endDoneTasks(data) {
			let storage = JSON.parse(localStorage.getItem('endTask')) || []
			storage.push(data)
			console.log(data, storage)
			localStorage.setItem('endTask', JSON.stringify(storage))
		},
		login() {
			this.$http.post('/nc-user-service/activity/sign').then(data => {
				localStorage.setItem('isLoad', localStorage.getItem('isLoad') + 1)
				this.getNum = data
				this.successLabel = 'Check in successfully !'
				this.loginPop = true

				this.buryingPoint('SignIn_Action') // 埋点

				this.buryingPoint('CheckIn_Action', this.dataInfo.signIn.continuousSignIn + 1) // 埋点

				// // 打点
				// const action = 'invokeMethod'
				// const methodName = 'daysCheckSuccess'
				// const params = {
				//     methodName,
				//     type: this.dataInfo.signIn.continuousSignIn + 1
				// }
				// invokeNative(params, action)
				this.getData()
			})
		},
		buryingPoint(actionName = '', value, eventName = 'Earn_Bonus') {
			const params = {
				methodName: 'tracker_event',
				eventName,
				action: actionName,
			}
			if (value != undefined) {
				params.value = value
			}
			invokeNative(params, 'invokeMethod')
		},
		getColor(i) {
			switch (i) {
				case 1:
					if (this.appInfo == 'iStory') {
						return
					} else if (this.appInfo == 'Webfiction') {
						return 'WebfictionText'
					} else if (this.appInfo == 'Webstories') {
						return 'WebstoriesText'
					} else if (this.appInfo == 'Webnovel') {
						return 'WebnovelText'
					} else if (this.appInfo == 'free2read') {
						return 'free2readText'
					} else if (this.appInfo == 'readme') {
						return 'readmeText'
					} else if (this.appInfo == 'weRead') {
						return 'weReadText'
					} else if (this.appInfo == 'readNow') {
						return 'readNowText'
					} else if (this.appInfo == 'GoodStory') {
						return 'GoodStoryText'
					} else if (this.appInfo == 'GoodStoryWeb') {
						return 'GoodStoryWebText'
					}
				case 2:
					if (this.appInfo == 'iStory') {
						return
					} else if (this.appInfo == 'Webfiction') {
						return 'WebfictionBackColor'
					} else if (this.appInfo == 'Webstories') {
						return 'WebstoriesBackColor'
					} else if (this.appInfo == 'Webnovel') {
						return 'WebnovelBackColor'
					} else if (this.appInfo == 'free2read') {
						return 'free2readBackColor'
					} else if (this.appInfo == 'readme') {
						return 'readmeBackColor'
					} else if (this.appInfo == 'weRead') {
						return 'weReadBackColor'
					} else if (this.appInfo == 'readNow') {
						return 'readNowBackColor'
					} else if (this.appInfo == 'GoodStory') {
						return 'GoodStoryBackColor'
					} else if (this.appInfo == 'GoodStoryWeb') {
						return 'GoodStoryWebBackColor'
					}
				case 3:
					if (this.appInfo == 'iStory') {
						return 'dayCheck'
					} else if (this.appInfo == 'Webfiction') {
						return 'dayCheck_fiction'
					} else if (this.appInfo == 'Webstories') {
						return 'dayCheck_story'
					} else if (this.appInfo == 'Webnovel') {
						return 'dayCheck_novel'
					} else if (this.appInfo == 'free2read') {
						return 'dayCheck_free2read'
					} else if (this.appInfo == 'readme') {
						return 'dayCheck_readme'
					} else if (this.appInfo == 'weRead') {
						return 'dayCheck_weRead'
					} else if (this.appInfo == 'readNow') {
						return 'dayCheck_readNow'
					} else if (this.appInfo == 'GoodStory') {
						return 'dayCheck_GoodStory'
					} else if (this.appInfo == 'GoodStoryWeb') {
						return 'dayCheck_GoodStoryWeb'
					}
				case 4:
					if (this.appInfo == 'iStory') {
						return 'dobluBox'
					} else if (this.appInfo == 'Webfiction') {
						return 'dobluBox_fiction'
					} else if (this.appInfo == 'Webstories') {
						return 'dobluBox_story'
					} else if (this.appInfo == 'Webnovel') {
						return 'dobluBox_novel'
					} else if (this.appInfo == 'free2read') {
						return 'dobluBo_free2read'
					} else if (this.appInfo == 'readme') {
						return 'dobluBo_readme'
					} else if (this.packageName == 'HiReader') {
						return 'dobluBo_HiReader'
					} else if (this.appInfo == 'weRead') {
						return 'dobluBo_weRead'
					} else if (this.appInfo == 'readNow') {
						return 'dobluBo_readNow'
					} else if (this.appInfo == 'GoodStory') {
						return 'dobluBo_GoodStory'
					} else if (this.appInfo == 'GoodStoryWeb') {
						return 'dobluBo_GoodStoryWeb'
					}
				case 5:
					if (this.appInfo == 'iStory') {
						return
					} else if (this.appInfo == 'Webfiction') {
						return 'WebfictionText2'
					} else if (this.appInfo == 'Webstories') {
						return 'WebstoriesText'
					} else if (this.appInfo == 'Webnovel') {
						return 'WebnovelText'
					} else if (this.appInfo == 'free2read') {
						return 'free2readText2'
					} else if (this.appInfo == 'readme') {
						return 'readmeText2'
					} else if (this.appInfo == 'weRead') {
						return 'weReadText2'
					} else if (this.appInfo == 'readNow') {
						return 'readNowText2'
					} else if (this.appInfo == 'GoodStory') {
						return 'GoodStoryText2'
					} else if (this.appInfo == 'GoodStoryWeb') {
						return 'GoodStoryWebText2'
					}
				case 6:
					if (this.appInfo == 'iStory') {
						return
					} else if (this.appInfo == 'Webfiction') {
						return 'taskBtn_fiction'
					} else if (this.appInfo == 'Webstories') {
						return 'taskBtn_stories'
					} else if (this.appInfo == 'Webnovel') {
						return 'taskBtn_novel'
					} else if (this.appInfo == 'free2read') {
						return 'taskBtn_free2read'
					} else if (this.packageName == 'HiReader') {
						return 'taskBtn_HiReader'
					} else if (this.appInfo == 'readme') {
						return 'taskBtn_readme'
					} else if (this.appInfo == 'weRead') {
						return 'taskBtn_weRead'
					} else if (this.appInfo == 'readNow') {
						return 'taskBtnreadNow'
					} else if (this.appInfo == 'GoodStory') {
						return 'taskBtnGoodStory'
					} else if (this.appInfo == 'GoodStoryWeb') {
						return 'taskBtnGoodStoryWeb'
					}
				case 7:
					if (this.appInfo == 'iStory') {
						return
					} else if (this.appInfo == 'Webfiction') {
						return 'successBtn_fiction'
					} else if (this.appInfo == 'Webstories') {
						return 'successBtn_stories'
					} else if (this.appInfo == 'Webnovel') {
						return 'successBtn_novel'
					} else if (this.appInfo == 'free2read') {
						return 'successBtn_free2read'
					} else if (this.appInfo == 'readme') {
						return 'successBtn_readme'
					} else if (this.appInfo == 'weRead') {
						return 'successBtn_weRead'
					} else if (this.appInfo == 'readNow') {
						return 'successBtn_readNow'
					} else if (this.appInfo == 'GoodStory') {
						return 'successBtn_GoodStory'
					} else if (this.appInfo == 'GoodStoryWeb') {
						return 'successBtn_GoodStoryWeb'
					}
			}
		},
		nativeClick(item) {
			if (item.done) {
				return
			}
			// console.log(item, 'item');
			// console.log(item.type, item.taskType, 'type')
			let action = ''
			let param = ''
			if (item.taskType == 1) {
				switch (item.type) {
					case 1: // 登录
						this.goNative('login')
						break
					case 2: // 添加书架
						this.goNative('library')
						break
					case 3: // 五星好评
						this.buryingPoint('5Star_Action') // 埋点

						invokeNative(
							{
								methodName: 'fiveStarReviews',
							},
							'invokeMethod'
						)
						break
					case 4: // Turn on notification
						this.buryingPoint('notification_Action') // 埋点

						invokeNative(
							{
								methodName: 'turnOnNotify',
							},
							'invokeMethod'
						)
						break
					case 6:
						console.log('邮箱验证')
						this.buryingPoint('VerifyEmail_Action') // 埋点

						this.goNative('setting')
						break
					case 7:
						this.code = null
						this.sharePop = true
						break
				}
			} else if (item.taskType == 3) {
				switch (item.type) {
					case 1: // Daily top up
						this.buryingPoint('TopUp_Action') // 埋点
						if (this.appInfo == 'GoodStoryWeb') {
							// this.goNative('topUp?methodName=topUp')
							invokeNative(
								{
									methodName: 'topUp',
								},
								'invokeMethod'
							)
						} else {
							// this.goNative('topUp')
							if (this.showPayImage) {
								this.openBrowser()
							} else {
								this.goNative('topUp')
							}
						}
						break
					case 2: // share
						this.buryingPoint('Share_Action') // 埋点
						this.goNative('discover')
						break
					case 4:
						// case 5:
						let that = this
						action = 'invokeMethod'
						const methodName = 'watchVideo'
						param = {
							methodName,
							type: 2,
							callback: function (data) {
								that.getData()
								that.getNum = 5
								that.successLabel = 'Complete the task !'
								that.loginPop = true
							},
						}
						this.buryingPoint('WatchVideo_Action') // 埋点
						invokeNative(param, action)
						break
					case 5:
						break
				}
			} else {
				switch (item.type) {
					case 2:
						this.goNative('library')
						break
					case 3:
						this.buryingPoint('15Mins_Action') // 埋点
						let matchData = item.topHint.match(/(\d+)\/(\d+)/)
						if (matchData) {
							let start = matchData[1]
							let end = matchData[2]
							console.log(start, 'start')
							console.log(end, 'end')

							if (Number(start) >= Number(end)) {
								this.$http
									.post('/nc-user-service/activity/read/task/done', {
										isGuest: false,
										taskType: 1,
									})
									.then(data => {
										this.getData()
									})
							} else {
								this.goNative('library')
							}
						}
						break
					case 4:
						console.log('30 min')
						this.buryingPoint('30Mins_Action') // 埋点
						let matchData2 = item.topHint.match(/(\d+)\/(\d+)/)
						if (matchData2) {
							let start = matchData2[1]
							let end = matchData2[2]
							console.log(start, 'start')
							console.log(end, 'end')

							if (Number(start) >= Number(end)) {
								this.$http
									.post('/nc-user-service/activity/read/task/done', {
										isGuest: false,
										taskType: 2,
									})
									.then(data => {
										this.getData()
									})
							} else {
								this.goNative('library')
							}
						}
						break
				}
			}
		},
		checkImgChoose() {
			if (this.appInfo == 'iStory') {
				return this.checkImg
			} else if (this.appInfo == 'Webfiction') {
				return this.checkImg_fiction
			} else if (this.appInfo == 'Webstories') {
				return this.checkImg_story
			} else if (this.appInfo == 'Webnovel') {
				return this.checkImg_novel
			}
		},
		getSuccessImg() {
			if (this.appInfo == 'iStory') {
				// return 'https://img.kandianreader.com/img/d889b94d2aed709915a477001bc1d489'
				return require('@/assets/images/d889b94d2aed709915a477001bc1d489.png')
			} else if (this.appInfo == 'Webfiction') {
				// return 'https://img.kandianreader.com/img/254fabfb5e7fdbb06dd400c8c592c77b'
				return require('@/assets/images/254fabfb5e7fdbb06dd400c8c592c77b.png')
			} else if (this.appInfo == 'Webstories') {
				// return 'https://img.kandianreader.com/img/7fefb1b224c75bc07864207047f2443f'
				return require('@/assets/images/7fefb1b224c75bc07864207047f2443f.png')
			} else if (this.appInfo == 'Webnovel') {
				// return 'https://img.kandianreader.com/img/1fb4faac86b8ff00819f55b0dbf5029e'
				return require('@/assets/images/1fb4faac86b8ff00819f55b0dbf5029e.png')
			} else if (this.appInfo == 'readme') {
				return require('@/assets/images/readme-success.png')
			} else if (this.appInfo == 'free2read') {
				return require('@/assets/images/free2read-success.png')
			} else if (this.appInfo == 'weRead') {
				return require('@/assets/images/d889b94d2aed709915a477001bc1d489.png')
			} else if (this.appInfo == 'readNow' || this.appInfo == 'Candy' || this.appInfo == 'Sweet') {
				return require('@/assets/images/readNow-success.png')
			} else if (this.appInfo == 'GoodStory') {
				return require('@/assets/images/free2read-success.png')
			} else if (this.appInfo == 'GoodStoryWeb') {
				return require('@/assets/images/Goodstoryweb-success.png')
			} else if (this.packageName == 'CrazyNovel' || this.packageName == 'LiteCrazyNovel') {
				return require('@/assets/images/dialog-icon.png')
			} else if (this.packageName == 'LoveNovel') {
				return require('@/assets/images/loveNovel-success.png')
			} else if (this.packageName == 'StoryRover') {
				return require('@/assets/images/StoryRover-success.png')
			} else if (this.packageName == 'DailyBooks') {
				return require('@/assets/images/DailyBooks-success.png')
			} else if (this.packageName == 'GoodFic') {
				return require('@/assets/images/GoodFic-success.png')
			} else if (this.packageName == 'InfinityStories') {
				return require('@/assets/images/InfinityStories-success.png')
			} else if(this.packageName == 'Readfic' && this.deviceName == 'ios'){
				return require('@/assets/images/readfic-success.png')
			}else if(this.packageName == 'iRomance'){
				return require('@/assets/images/iRomance-success.png')
			}else {
				return require('@/assets/images/d889b94d2aed709915a477001bc1d489.png')
			}
		},
		goHistory() {
			this.jump('bonusHistory', 1)
			// if (this.appInfo == 'readNow') {
			//     this.jump('recordList', 1)
			// } else {
			//     this.jump('bonusHistory', 1)
			// }
		},
		goNative(pageUrl) {
			let action = 'goToNative'
			let param = {
				page: pageUrl,
			}
			invokeNative(param, action)
		},
		jump(path, hideNav) {
			const i = window.location.href
			const url = i.split('#')[0] + `#/${path}?hideNav=${hideNav}&tabIndex=1`
			const action = 'openWebView'
			const params = {
				url: encodeURIComponent(url),
			}
			invokeNative(params, action)
		},
	},
}
</script>
<style lang="scss" scoped>
@import '@/assets/style/welfare.scss';
</style>
